import { render } from "./BookADemo.vue?vue&type=template&id=08e3a393"
import script from "./BookADemo.vue?vue&type=script&lang=js"
export * from "./BookADemo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__